import { getData } from "@/utils/fetch";
import debounce from "debounce-promise";
import { defineStore } from "pinia";

let debouncedFetch = debounce(getData, 500);

export const useOrderStatusStore = defineStore({
  id: "orderstatus",
  state: () => ({
    orderStatus: {},
  }),
  getters: {
    getData(state) {
      return state.orderStatus.data;
    },
  },
  actions: {
    async getOrderStatus(params) {
      this.orderStatus = { loading: true };

      const dataparams = {
        limit: params?.limit || 20,
        offset: params?.offset || 0,
        startdate: params?.startdate,
        enddate: params?.enddate,
      };

      try {
        const result = await debouncedFetch("order_status", dataparams);
        this.orderStatus = { ...result.data };
      } catch (error) {
        console.log(error);
        this.orderStatus = { error };
      }
    },
  },
});
